import { Module, GetterTree, ActionTree, MutationTree } from 'vuex';
import http from '@/http'

const state: MediaFileState = {
  mediaFiles: []
}

const getters: GetterTree<MediaFileState, RootState> = {

}

const actions: ActionTree<MediaFileState, RootState> = {
  fetchList({ commit }) {
    return http.v1.mf.fetchList().then(response => {
      commit('SET_MEDIA_FILES', response.data.data)
    })
  },
  updateRelation(context, { oid, payload }) {
    return http.v1.mf.updateRelation(oid, payload)
  },
}

const mutations: MutationTree<MediaFileState> = {
  SET_MEDIA_FILES(state, payload) {
    state.mediaFiles = payload
  }
}

const ali: Module<MediaFileState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}

export default ali